import { Card } from "primereact/card";

const data = [
  {
    title: "Built-in Explainability",
    text: "Understand every result through transparent feature attributions and symbolic decision logic, making the reasoning behind predictions fully interpretable."
  },
  {
    title: "Uncompromising Privacy",
    text: "Raw data never leaves your device. Before cloud training, it is transformed locally into irreversible symbolic representations."
  },
  {
    title: "No-Code Experience",
    text: "Zero configuration required. Start one-click modeling instantly without manual algorithm selection or parameter tuning."
  },
  {
    title: "Small-Data Agility",
    text: "Unlock powerful modeling capabilities even with limited datasets. High-performance intelligence without the need for big data."
  },
  {
    title: "Stability & Consistency",
    text: "Identical input data produces stable and highly consistent model behavior, supporting robust evaluation and reproducible results."
  },
  {
    title: "Local Intelligence",
    text: "Predict outcomes, extract knowledge, and simulate scenarios locally—ensuring ultra-low latency, constant availability, and complete data sovereignty."
  }
];

export default function Advantages() {
  return (
    <section className="section" id="advantage" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
      <h2 style={{ color:"#3b5283 !important",fontSize: 36, textAlign: "center", marginBottom: "2.5rem", fontWeight: 600 }}>
        Core Advantages
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
          gap: 24,
          marginTop: 40,
        }}
      >
        {data.map((item) => (
          <Card key={item.title} title={item.title}>
            <p>{item.text}</p>
          </Card>
        ))}
      </div>
    </section>
  );
}

